import { view, textFormatting, anodum } from '@yola/ws-sdk';
import wrapElement from './wrap-element';

const {
  wrappersTypes: { decoration },
} = textFormatting.constants;

const SHIFTED_OFFSET = 1;

const containsOnlySpaces = (string) => string.trim() === '';

const setSelection = ({ anchorNode, focusNode, anchorOffset, focusOffset }) => {
  const liveDocument = view.accessors.getLiveDocument();
  const selection = textFormatting.accessors.getAdvancedSelection();
  const range = liveDocument.createRange();

  range.setStart(anchorNode, anchorOffset);
  range.setEnd(focusNode, focusOffset);

  selection.removeAllRanges();
  selection.addRange(range);
  selection.refresh();
};

const correctWrongSelectionOffset = () => {
  const { anchorNode, focusNode, anchorOffset, focusOffset } =
    textFormatting.accessors.getAdvancedSelection();

  const isAnchorTextNode = anchorNode && anodum.isTextNode(anchorNode);
  const isFocusTextNode = focusNode && anodum.isTextNode(focusNode);

  if (!isAnchorTextNode || !isFocusTextNode) return;

  const isAnchorNodePartOfDecoration = Boolean(
    anchorNode.parentNode.closest(`${decoration.tagName}`)
  );
  const isFocusNodePartOfDecoration = Boolean(
    focusNode.parentNode.closest(`${decoration.tagName}`)
  );
  const hasEmptyUnselectedSpaceAtStart =
    anchorOffset === SHIFTED_OFFSET && containsOnlySpaces(anchorNode.nodeValue.slice(0, 1));
  const hasEmptyUnselectedSpaceAtEnd =
    focusOffset === focusNode.nodeValue.length - SHIFTED_OFFSET &&
    containsOnlySpaces(focusNode.nodeValue.slice(-1));

  if (
    (isAnchorNodePartOfDecoration && hasEmptyUnselectedSpaceAtStart) ||
    (isFocusNodePartOfDecoration && hasEmptyUnselectedSpaceAtEnd)
  ) {
    setSelection({
      anchorNode,
      focusNode,
      anchorOffset: hasEmptyUnselectedSpaceAtStart ? 0 : anchorOffset,
      focusOffset: hasEmptyUnselectedSpaceAtEnd ? focusNode.nodeValue.length : focusOffset,
    });
  }
};

const wrapInDecorationElement = (elementId, attributes) => {
  correctWrongSelectionOffset();

  const wrappedElements = [
    ...wrapElement(elementId, {
      ...decoration,
      attributes,
    }),
  ];

  return wrappedElements;
};

export default wrapInDecorationElement;
